import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { LenisProvider } from '@providers/LenisProvider';

import App from './app';

import './styles/index.scss';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LenisProvider>
        <App />
      </LenisProvider>
    </QueryClientProvider>
  </HelmetProvider>
);
